<template>
    <footer id="footer">
        <div class="footer-top">
            <v-container class="footer-container">
                <v-row>
                    <!-- Contact Information -->
                    <v-col cols="12" sm="6" lg="3" class="justify-center">
                        <div class="footer-info">
                            <h3>{{ terms.brand }}</h3>
                            <p>
                                {{ terms.contact_street }}
                                <br />
                                {{ terms.contact_city }}, {{ terms.contact_country }}
                                <br /><br />
                                <strong>{{ terms.phone_term }}:</strong><br />
                                {{ terms.contact_phone1 }}<br />
                                {{ terms.contact_phone2 }}<br />
                                <strong>{{ terms.email_term }}:</strong><br />
                                {{ terms.contact_email_address }}
                            </p>
                        </div>
                    </v-col>

                    <!-- Useful Links -->
                    <v-col cols="6" sm="6" lg="3" class="footer-links justify-center">
                        <h4>{{ terms.useful_links_term }}</h4>
                        <ul>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a href="#hero">{{ terms.menu_home }}</a>
                            </li>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a href="#about">{{ terms.menu_about }}</a>
                            </li>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a :href="productsHref">{{ terms.offers || 'Products' }}</a>
                            </li>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a href="#portfolio">{{ terms.menu_gallery }}</a>
                            </li>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a href="#contact">{{ terms.menu_contact }}</a>
                            </li>
                        </ul>
                    </v-col>

                    <!-- Services -->
                    <v-col cols="6" sm="6" lg="3" class="footer-links justify-center">
                        <h4>{{ terms.our_services }}</h4>
                        <ul>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a href="#services">{{ terms.engineering_design_term }}</a>
                            </li>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a href="#services">{{ terms.consulting_term }}</a>
                            </li>
                            <li>
                                <i class="bx bx-chevron-right"></i>
                                <a href="#services">{{ terms.prototypes_term }}</a>
                            </li>
                        </ul>
                    </v-col>

                    <!-- Follow us -->
                    <v-col cols="12" sm="6" lg="3" class="footer-links justify-center">
                        <h4>{{ terms.follow_us }}</h4>
                        <ul class="social-media-links">
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=100094178810701" target="_blank" rel="noopener noreferrer" :title="`${terms.follow_us_on} Facebook`">
                                    <i class="fab fa-facebook-square"></i>{{ terms.follow_us_on }} Facebook
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/avem.offi/" target="_blank" rel="noopener noreferrer" :title="`${terms.follow_us_on} Instagram`">
                                    <i class="fab fa-instagram"></i>{{ terms.follow_us_on }} Instagram
                                </a>
                            </li>
                            <li>
                                <a href="https://www.tiktok.com/@avem.official?lang=en" target="_blank" rel="noopener noreferrer" :title="`${terms.follow_us_on} TikTok`">
                                    <i class="fab fa-tiktok"></i>{{ terms.follow_us_on }} TikTok
                                </a>
                            </li>
                        </ul>
                    </v-col>
                </v-row>
            </v-container>
        </div>

        <!-- Footer Bottom -->
        <v-container>
            <v-row>
                <v-col class="d-flex align-center justify-center">
                    &copy; {{ terms.copyright }}
                    <strong><span>&nbsp;{{ terms.brand }}</span></strong>.
                    {{ terms.all_rights_reserved }}
                </v-col>
            </v-row>            
        </v-container>
    </footer>
</template>

<script setup>
    import { computed } from "vue";
    import { useStore } from "vuex";
    import '@fortawesome/fontawesome-free/css/all.css';

    // Access the Vuex store
    const store = useStore();

    // Computed property for terms
    const terms = computed(() => store.state.terms);
    const isEn = computed(() => store.state.languageCode === 'en');
    const productsHref = computed(() => isEn.value ? '/en/offers' : '/offers');
</script>

<style scoped>
    /*TPL-FOOTER*/
    
    @import 'boxicons/css/boxicons.min.css';

    #footer {
        background: black;
        color: #fff;
        font-size: 14px;
    }
    #footer a {
        text-decoration: none;
    }
    #footer .footer-top {
        background: #151515;
        border-bottom: 1px solid #222222;
        padding: 60px 0 30px 0;
    }
    #footer .footer-top .footer-info {
        margin-bottom: 30px;
    }
    #footer .footer-top .footer-info h3 {
        font-size: 28px;
        margin: 0 0 20px 0;
        padding: 2px 0 2px 0;
        line-height: 1;
        font-weight: 700;
        text-transform: uppercase;
    }
    #footer .footer-top .footer-info h3 span {
        color: #ffc451;
    }
    #footer .footer-top .footer-info p {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 0;
        font-family: "Raleway", sans-serif;
        color: #fff;
    }
    #footer .footer-top h4 {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
        position: relative;
        padding-bottom: 12px;
    }
    #footer .footer-top .footer-links {
        margin-bottom: 30px;
    }
    #footer .footer-top .footer-links ul {
        font-size: 16px;
        list-style: none;
        padding: 0;
        margin: 0;
    }
    #footer .footer-top .footer-links ul i {
        padding-right: 2px;
        color: #ffc451;
        font-size: 18px;
        line-height: 1;
    }
    #footer .footer-top .footer-links ul li {
        padding: 10px 0;
        display: flex;
        align-items: center;
    }
    #footer .footer-top .footer-links ul li:first-child {
        padding-top: 0;
    }
    #footer .footer-top .footer-links ul a {
        color: #fff;
        transition: 0.3s;
        display: inline-block;
        line-height: 1;
    }
    #footer .footer-top .footer-links ul.social-media-links a {
        transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    #footer .footer-top .footer-links ul.social-media-links a:hover {
        color: #ffc451;
        transform: translateX(6px) scale(1.05);
        filter: drop-shadow(0 2px 6px rgba(255, 196, 81, 0.5));
    }

    .footer-container {
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
        width: 85%;
    }

    #footer .social-media-links i {
        margin: 0px 10px;
    }

    @media (max-width: 959px) {
        .footer-container {
            width: 100% !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
        }

        #footer .footer-top {
            padding: 35px 0 20px 0 !important;
        }

        #footer .footer-top .footer-info h3 {
            font-size: 22px !important;
            margin-bottom: 10px !important;
        }

        #footer .footer-top .footer-info p {
            font-size: 14px !important;
            line-height: 20px !important;
        }

        #footer .footer-top h4 {
            font-size: 16px !important;
            padding-bottom: 8px !important;
            margin-bottom: 10px !important;
        }

        #footer .footer-top .footer-links {
            margin-bottom: 20px !important;
        }

        #footer .footer-top .footer-links ul {
            font-size: 14px !important;
        }

        #footer .footer-top .footer-links ul li {
            padding: 6px 0 !important;
        }
    }

    @media (max-width: 600px) {
        .footer-container {
            padding-left: 16px !important;
            padding-right: 16px !important;
        }

        #footer .footer-top {
            padding: 25px 0 15px 0 !important;
        }

        #footer .footer-top .footer-info {
            margin-bottom: 20px !important;
        }

        #footer .footer-top .footer-info h3 {
            font-size: 20px !important;
        }

        #footer .footer-top .footer-info p {
            font-size: 13px !important;
            line-height: 18px !important;
        }

        #footer .footer-top h4 {
            font-size: 15px !important;
        }

        #footer .footer-top .footer-links ul {
            font-size: 13.5px !important;
        }

        #footer .footer-top .footer-links ul li {
            padding: 5px 0 !important;
        }

        #footer .social-media-links i {
            margin: 0px 6px 0px 0px !important;
        }
    }
</style>